/*
 * AI-GENERATED
 * Microsoft 365 Copilot
 * LLM: GPT-5 reasoning
 * Tarkistanut Arttu Pietarinen
 * 2026-09-15
 */
import strings from '../../../translations';
import { useAppSelector } from '../../../state/hooks';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { motion } from 'motion/react';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { dropdownVariants } from '../utils/SearchUtil';

const StyledDropDown = styled(motion.div)`
  width: 100%;
  padding: 0 1px;
  overflow: auto;
  background-color: ${(props) => props.theme.colors.mainWhite};
`;
const StyledItemButton = styled.button`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.5em;
  padding: 0.5em 1em;
  border: 0;
  border-radius: 5px;
  color: ${(props) => props.theme.colors.mainWhite};
  background-color: ${(props) => props.theme.colors.mainColor1};
  cursor: pointer;
  text-align: left;
`;
const StyledTitle = styled.span`
  overflow: hidden;
  font-size: 14px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const StyledAttributes = styled.dl`
  margin: 0;
`;
const StyledAttribute = styled.div`
  display: grid;
  grid-template-columns: minmax(100px, 1fr) minmax(0, 2fr);
  gap: 0.5em;
  padding: 4px;
  border-bottom: 1px solid #ccc;
`;
const StyledKey = styled.dt`
  overflow: hidden;
  font-weight: 600;
  text-overflow: ellipsis;
`;
const StyledValue = styled.dd`
  overflow-wrap: anywhere;
  margin: 0;
`;
const StyledMessage = styled.div`
  margin-top: 8px;
  text-align: center;
`;
const StyledError = styled(StyledMessage)`
  color: ${(props) => props.theme.colors.secondaryColorDarkOrange || '#c55'};
`;

const getItemKey = (item) => `${item.searchMetadataId}:${item.entityId}`;
const getAttributes = (item) => item.fulltextJson ?? {};
const getTitle = (item) => {
  const attributes = getAttributes(item);
  return (
    attributes.nimi ?? attributes.name ?? attributes.title ?? item.entityId
  );
};
const formatValue = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  return typeof value === 'object' ? JSON.stringify(value) : String(value);
};

const IndexSearchResultPanel = ({ onResultSelect }) => {
  const {
    status = 'idle',
    query = '',
    items = [],
    error = null
  } = useAppSelector((state) => state.rpc.featureSearchResults);

  const featureSearchResults = useAppSelector(
    (state) => state.rpc.featureSearchResults
  );
  const [openItemKey, setOpenItemKey] = useState(null);

  const toggleItem = (item) => {
    const itemKey = getItemKey(item);
    const nextItemKey = openItemKey === itemKey ? null : itemKey;
    setOpenItemKey(nextItemKey);
    if (nextItemKey) onResultSelect?.(item);
  };

  useEffect(() => {
    console.info('items', items);
    console.info('status', status);
    console.info('query', query);
    console.info('error', error);
    console.info('featureSearchResults', featureSearchResults);
  }, [items, status, query, error, featureSearchResults]);

  return (
    <StyledDropDown
      variants={dropdownVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition="transition"
    >
      {error && <StyledError role="alert">{error}</StyledError>}
      {items.map((item) => {
        const itemKey = getItemKey(item);
        const isOpen = openItemKey === itemKey;
        const detailsId = `index-search-result-${itemKey}`;
        return (
          <div key={itemKey}>
            <StyledItemButton
              type="button"
              aria-expanded={isOpen}
              aria-controls={detailsId}
              onClick={() => toggleItem(item)}
            >
              <StyledTitle>{getTitle(item)}</StyledTitle>
              <FontAwesomeIcon icon={isOpen ? faAngleUp : faAngleDown} />
            </StyledItemButton>
            {isOpen && (
              <StyledAttributes id={detailsId}>
                {Object.entries(getAttributes(item)).map(([key, value]) => (
                  <StyledAttribute key={key}>
                    <StyledKey>{key}</StyledKey>
                    <StyledValue>{formatValue(value)}</StyledValue>
                  </StyledAttribute>
                ))}
              </StyledAttributes>
            )}
          </div>
        );
      })}
      {status === 'loading' && (
        <StyledMessage role="status">
          {strings.search?.searching ?? 'Searching...'}
        </StyledMessage>
      )}
      {status === 'succeeded' && query && items.length === 0 && (
        <StyledMessage>{strings.search.feature.noResults}</StyledMessage>
      )}
    </StyledDropDown>
  );
};

export default IndexSearchResultPanel;
